const MSG_GLOBAL = {
  REQUIRED: 'This field is required',
};

export default MSG_GLOBAL;
